module.exports = __webpack_public_path__ + "static/media/Resume12_2023.d0ad7a7c.pdf";